import React from "react";
import MuiTextField from "@mui/material/TextField";

const DisplayField = React.forwardRef(
    (
        {
            label,
            value,
            defaultValue,
            errorMsg,
            containerClass,
            entityName, //removed due to useless warnings
            virtualKeyboardLayout, //removed due to useless warnings
            virtualKeyboardLang, //removed due to useless warnings
            onChangeInput, //removed due to useless warnings
            InputProps,
            ...restProps
        },
        ref
    ) => {
        return (
            <div className={`input-field-sec ${errorMsg ? "error-field" : ""} ${containerClass || ""}`}>
                <MuiTextField
                    inputRef={ref}
                    variant="outlined"
                    helperText={label}
                    value={value || defaultValue || ""}
                    InputProps={{
                        ...InputProps,
                        readOnly: true
                    }}
                    {...restProps}
                />
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default DisplayField;
